import React, { useEffect } from 'react'
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, ReactDataTable } from '../../../../components/Component'
import { WEBSITE_BASE_URL } from '../../../../config'
import userImage from '../../../../assets/images/user.jpg'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'
import { getAllDeliveryPartner } from '../../../../redux/admin/user/action'
import { useDispatch, useSelector } from 'react-redux'

function DeliveryPartner() {
    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({
        users: state.users.delivery_partners,
    });

    const { users } = useSelector(getSelectors);

    // get all users  onload
    useEffect(() => {
        dispatch(getAllDeliveryPartner())
    }, [])

    //headers of table
    const UserHeading = [
        {
            name: "ID",
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => {
                return (
                    <div className="user-card">
                        {/* {row.image ?
                            <img src={WEBSITE_BASE_URL + row.image}
                                className="user-image-round my-2"
                                alt='sylcon_user'
                            />
                            :
                            <img src={userImage}
                                className="user-image-round my-2"
                                alt='sylcon_user'
                            />} */}
                        <div className=" ">
                            {row.name}
                        </div>
                    </div>
                );
            },
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            hide: 370,
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
            hide: 370,
        },
        {
            name: "Status",
            selector: (row) => row.is_active,
            compact: true,
            style: { paddingRight: "20px" },

            cell: (row) => {
                return (
                    <Badge className="badge-dot" color={row?.is_active == '0' ? "danger" : "success"}>
                        {row?.is_active == '0'  ? "Inactive" : "Active"}
                    </Badge>

                );
            },
        },
        {
            name: "Role",

            compact: true,
            style: { paddingRight: "20px" },

            cell: (row) => {
                return (
                    // <Badge pill color="secondary">
                    //     {row?.roles && row?.roles[0] ? row?.roles[0]?.name : "User Has No Role"}
                    // </Badge>
                    <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>

                );
            },
        }, {
            name: "Created At",
            selector: (row) => moment(row.created_at).fromNow(),
            sortable: true,
            hide: "sm",

        },
        {
            name: "Actions",
            compact: true,
            grow: 1,
            style: { paddingRight: "20px" },
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />

                </div>

            ),
            sortable: false,
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" href={'/edit-user/' + row.id}>
                                <Icon name="pen" />
                                Edit
                            </DropdownItem>
                        </li>
                    </ul>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" href={'/manage-delivery-partner/' + row.id}>
                                <Icon name="account-setting-fill" />
                                Manage Store
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
       
        <React.Fragment>
            <Head title="Delivery Partner "></Head>

            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Delivery Partner
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have total {users.length} Delivery Partner .</p>
                            </BlockDes>
                        </BlockHeadContent>

                    </BlockBetween>
                </BlockHead>


                {/* datatable */}
                <ReactDataTable
                    data={users}
                    columns={UserHeading}

                    pagination
                />

            </Content>
        </React.Fragment>
    )
}

export default DeliveryPartner
